import React from "react";
import styled from "styled-components";
import RightArrowIcon from "../Icons/RightArrowIcon";
import { BreakPoints } from "../../constants";
import CheckmarkIcon from "../Icons/CheckmarkIcon";
import CloseIcon from "../Icons/CloseIcon";

interface Message {
  message: string;
  checkmark: boolean;
}

interface RoleCardProps {
  onClick: () => void;
  title: string;
  icon: React.ReactNode;
  messages: Message[];
}

const StyledRoleCard = styled.div.attrs({ className: "role-card" })`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 10px 0px rgba(54, 56, 61, 0.2);
  padding: 16px;
  cursor: pointer;
  width: 100%;

  .top-section {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    justify-content: space-between;

    .icon-title-container {
      display: flex;
      align-items: center;
    }

    .icon {
      padding-right: 16px;
    }

    .title {
      color: #36383d;
      font-family: Rubik;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      text-transform: capitalize;
      flex-grow: 1;
      text-align: center;
    }
  }

  .messages {
    display: flex;
    flex-wrap: wrap;

    @media (max-width: ${BreakPoints.sm}) {
      flex-direction: column;
    }

    .message-item {
      display: flex;
      align-items: center;
      padding-bottom: 8px;
      width: 50%;

      @media (max-width: ${BreakPoints.sm}) {
        width: 100%;
      }

      .checkmark {
        padding-right: 8px;
        display: flex;
        align-items: center;
      }

      .text {
        color: #36383d;
        font-family: Rubik;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
`;

const RoleCard: React.FC<RoleCardProps> = ({ onClick, title, icon, messages }) => (
  <StyledRoleCard onClick={onClick}>
    <div className="top-section">
      <div className="icon-title-container">
        <div className="icon">{icon}</div>
        <div className="title">{title}</div>
      </div>
      <RightArrowIcon />
    </div>
    <div className="messages">
      {messages.map((msg, index) => (
        <div className="message-item" key={index}>
          <div className="checkmark">{msg.checkmark ? <CheckmarkIcon width={12} height={20} color="#0A7B38" /> : <CloseIcon width={12} height={20} color="#D10606" />}</div>
          <div className="text">{msg.message}</div>
        </div>
      ))}
    </div>
  </StyledRoleCard>
);

export default RoleCard;
